module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "goods-list-wrapper"
  }, [_c('div', {
    staticClass: "header-wrapper"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.shopInfo.name) + " / 商品管理")]), _vm._v(" "), _c('div', {
    staticClass: "btn-group"
  }, [_c('router-link', {
    attrs: {
      "to": '/shop/' + _vm.shopInfo.id + '/tags'
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    }
  }, [_vm._v("管理商品分类")])], 1), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": '/shop/' + _vm.shopInfo.id + '/goods/add'
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "plus",
      "size": "small"
    }
  }, [_vm._v("添加商品")])], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "manager-wrapper"
  }, [_c('el-button', {
    on: {
      "click": _vm.changeGoodsStatus
    }
  }, [_vm._v("查看" + _vm._s(_vm.goodsStatus === 1 ? '已下架' : '在售') + "产品")])], 1), _vm._v(" "), _c('div', {
    staticClass: "table-wrapper"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.goodsList.filter(function (data) { return !_vm.search || data.name.toLowerCase().includes(_vm.search.toLowerCase()); }),
      "stripe": "",
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "align": "center",
      "type": "selection"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "imgs",
      "label": "产品图片",
      "width": "180"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "goods-pic-col"
        }, [_c('img', {
          attrs: {
            "src": _vm._f("ossurl")(scope.row.imgs[0])
          }
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "show-overflow-tooltip": "",
      "prop": "name",
      "label": "商品名字",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "total_sales",
      "label": "已售"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "stock",
      "label": "剩余库存"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "status",
      "sortable": "",
      "formatter": _vm.getStatus,
      "label": "状态"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "prop": "type",
      "sortable": "",
      "formatter": _vm.getSpecType,
      "label": "多规格类型"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          }
        }, [_c('router-link', {
          attrs: {
            "to": ("/shop/" + (_vm.shopInfo.id) + "/goods/edit?goodsid=" + (scope.row.id))
          }
        }, [_vm._v("编辑")])], 1), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "warning"
          },
          on: {
            "click": function($event) {
              return _vm.updateGoodsStatus(scope.row.id, scope.$index)
            }
          }
        }, [_vm._v("\n            " + _vm._s(_vm.goodsStatus === 1 ? '下架' : '上架') + "\n          ")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "size": "small",
            "type": "danger"
          },
          on: {
            "click": function($event) {
              return _vm.deleteGoods(scope.row.id, scope.$index)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-block"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "layout": "total, prev, pager, next, jumper",
      "total": _vm.totalCount
    },
    on: {
      "current-change": _vm.currentPageChanged,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aea82d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shop/goods-list.vue
// module id = 810
// module chunks = 1